export default "__VITE_ASSET__C$9XtFF___"